import modelGif from '@components/process/assets/3d-model.gif'
import dateGif from '@components/process/assets/date.gif'
import ListGif from '@components/process/assets/list-mult.gif'
import photoGif from '@components/process/assets/photo.gif'
import sampleTextGif from '@components/process/assets/Sample-text.gif'
import sampleImageGif from '@components/process/assets/Sample-image.gif'
import sampleVideoGif from '@components/process/assets/Sample-video.gif'
import numberGif from '@components/process/assets/Number.gif'
import textGif from '@components/process/assets/Text.gif'
import yesOrNoGif from '@components/process/assets/yes-or-no.gif'
import gpsGif from '@components/process/assets/gps.gif'
import drawGif from '@components/process/assets/Draw.gif'
import scoreGif from '@components/process/assets/score.gif'
import calculatorGif from '@components/process/assets/calculator.gif'
import todoGif from '@components/process/assets/todo.gif'
import audioGif from '@components/process/assets/audio.gif'
import sampleGif from '@components/process/assets/samples.gif'
import qrcodeGif from '@components/process/assets/qrcode.gif'


export const exportedModelGif = modelGif
export const exporteddateGif = dateGif
export const exportedListGiff = ListGif
export const exportedphotoGif = photoGif
export const exportedsampleTextGif = sampleTextGif
export const exportedsampleImageGif = sampleImageGif
export const exportedsampleVideoGif = sampleVideoGif
export const exportednumberGif = numberGif
export const exportedtextGif = textGif
export const exportedyesOrNoGif = yesOrNoGif
export const exportedgpsGif = gpsGif
export const exporteddrawGif = drawGif
export const exportedScoreGif = scoreGif
export const exportedCalculatorGif = calculatorGif
export const exportedToDoGif = todoGif
export const exportedAudioGif = audioGif
export const exportedSampleGif = sampleGif
export const exportedQRCodeGif = qrcodeGif
